/**
 * Faturamento Configuracao
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {FaixaValorFaturamento} from '@/model/resource/FaixaValorFaturamento'

export class FaturamentoConfiguracao extends Resource {
  idResponsavelFaturamentoConfiguracaoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  diaInicial: number | null = null
  diaFinal: number | null = null
  dataVencimentoContrato: string | null = null
  dataUltimaCorrecao: string | null = null
  valorIroute: number | null = null
  valorBi: number | null = null
  valorTorreControle: number | null = null
  valorAcessoLimitadoTransportadores: number | null = null
  valorConsultaPedido: number | null = null
  valorCheckinAutomatico: number | null = null
  valorNotificacaoSMS: number | null = null
  valorNotificacaoWhatsup: number | null = null
  valorCheckList: number | null = null
  valorContraSenha: number | null = null
  valorExibirMapaSacPainel: number | null = null
  valorVoip: number | null = null
  numeroProtheus: number | null = null
  observacao: string | null = null
  listaFaixaValorFaturamento: FaixaValorFaturamento[] = []
  ehGrupoEconomico: boolean = false
  ativo: boolean = true

  get $id() {
    return this.idResponsavelFaturamentoConfiguracaoPk
  }
  set $id(val) {
    this.idResponsavelFaturamentoConfiguracaoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  reset() {
    this.diaFinal = null
    this.diaInicial = null
    this.dataVencimentoContrato = null
    this.dataUltimaCorrecao = null
    this.valorIroute = null
    this.valorBi = null
    this.valorTorreControle = null
    this.valorAcessoLimitadoTransportadores = null
    this.valorConsultaPedido = null
    this.valorCheckinAutomatico = null
    this.valorNotificacaoSMS = null
    this.valorNotificacaoWhatsup = null
    this.valorCheckList = null
    this.valorContraSenha = null
    this.valorExibirMapaSacPainel = null
    this.valorVoip = null
    this.listaFaixaValorFaturamento = []
    this.ehGrupoEconomico = false
    this.ativo = false
    this.idResponsavelFaturamentoConfiguracaoPk = 0
    this.numeroProtheus = null
    this.observacao = null
  }

  restart() {
    this.diaFinal = null
    this.diaInicial = null
    this.dataVencimentoContrato = null
    this.dataUltimaCorrecao = null
    this.valorIroute = null
    this.valorBi = null
    this.valorTorreControle = null
    this.valorAcessoLimitadoTransportadores = null
    this.valorConsultaPedido = null
    this.valorCheckinAutomatico = null
    this.valorNotificacaoSMS = null
    this.valorNotificacaoWhatsup = null
    this.valorCheckList = null
    this.valorContraSenha = null
    this.valorExibirMapaSacPainel = null
    this.valorVoip = null
    this.listaFaixaValorFaturamento = []
    this.ehGrupoEconomico = false
    this.ativo = true
    this.responsavel = null
    this.idResponsavelFaturamentoConfiguracaoPk = 0
    this.numeroProtheus = null
    this.observacao = null
  }

  /**
   * Gets a instance of a given ID of FaturamentoConfig
   */
  async getFaturamentoConfiguracao(id: number) {
    return await Request.get(`/admin/faturamento-configuracao/${id}`)
      .name('getFaturamentoConfiguracao')
      .as(this)
      .getData()
  }

  /**
   * Persists a new instance of Faturamento. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistFaturamentoConfiguracao() {
    return await Request.post(`/admin/faturamento-configuracao`, this)
      .name('persistFaturamentoConfiguracao')
      .asNumber()
      .getData()
  }
}
